import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectFirstPrequal, selectTerm } from 'src/store/selectors/prequal'

const LoanTermContainer = compose(
  connect(state => {
    const prequal = selectFirstPrequal(state)
    return selectTerm(prequal)
  })
)

export default LoanTermContainer
